import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { QueryFeature } from '../../../config/queryClient';

interface TaxLotDetailsDTO {
  units: number;
  price: number;
  proceeds: number;
  costBasis: number;
  shortTerm: number;
  longTerm: number;
  total: number;
  acquiredDate: string;
  sellDate: string;
  holdingPeriod: string;
}

interface PositionsDTO {
  name: string;
  accountNumber: string;
  ticker: string;
  units: number;
  price: number;
  proceeds: number;
  costBasis: number;
  shortTerm: number;
  longTerm: number;
  gainLoss: number;
  taxLotDetails: TaxLotDetailsDTO[];
}

export interface RealizedGainLossDTO {
  name: string;
  accountNumber: string;
  proceeds: number;
  costBasis: number;
  shortTerm: number;
  longTerm: number;
  gainLoss: number;
  holdingPeriod: string;
  positions: PositionsDTO[];
}

const fetchRealizedGainLoss = async ({
  clientId,
  accountId,
  groupId,
  period,
  startDate,
  endDate,
}: {
  clientId: string;
  accountId?: string;
  groupId?: string;
  period?: number;
  startDate?: string;
  endDate?: string;
}): Promise<RealizedGainLossDTO[]> =>
  authFetch(
    urlWithParams(
      '/Consumer/OrionAccountsWidgets/RealizedGainLossDetails',
      {
        clientId,
        accountId: accountId || null,
        groupId: groupId || null,
        period,
        startDate,
        endDate,
      },
      { skipNulls: true },
    ),
  );

export const REALIZED_GAIN_LOSS_QUERY_KEY = 'realizedGainLoss';

export const useRealizedGainLossQuery = ({
  clientId,
  accountId,
  groupId,
  period,
  startDate: _startDate,
  endDate: _endDate,
}: {
  clientId: string;
  accountId?: string;
  groupId?: string;
  period?: number;
  startDate?: string;
  endDate?: string;
}) => {
  const startDate = period === undefined ? _startDate : undefined;
  const endDate = period === undefined ? _endDate : undefined;

  return useQuery(
    [
      QueryFeature.AccountPerformanceReporting,
      REALIZED_GAIN_LOSS_QUERY_KEY,
      clientId,
      accountId,
      groupId,
      period,
      startDate,
      endDate,
    ],

    () => fetchRealizedGainLoss({ clientId, accountId, groupId, period, startDate, endDate }),
  );
};
